import { z } from 'zod';
export var ApplicationNotice = z.object({
  id: z.string(),
  message: z.string(),
  intent: z["enum"](['warning', 'negative', 'positive']),
  regarding: z["enum"](['application', 'student', 'education', 'exams', 'payment', 'recruitment_partner', 'commission']),
  importance: z["enum"](['high', 'medium']).nullish(),
  link: z.object({
    href: z.string(),
    label: z.string()
  }).optional()
});
export var ApplicationNoticeResponse = z.object({
  attributes: z.object({}).passthrough(),
  id: z.string(),
  type: z.literal('application_notice')
});